import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from 'src/app/users/users.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';

@Component({
  selector: 'app-form-templates',
  templateUrl: './form-templates.component.html',
  styleUrls: ['./form-templates.component.scss']
})
export class FormTemplatesComponent implements OnInit {
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  formTemplateList: any = [];
  formTemplateListTemp: any = [];
  formTemplateData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages


  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.formTemplateList.length, page, this.perPage, targetpage);
    this.pagedItems = this.formTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    console.log(this.columnLists);
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        console.log(error);
      }
    })
    this.isProcessing = false;

  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.formTemplateListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.formTemplateListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.formTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.formTemplateList = [];
    const data = {

      gridName: "FORM_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "ONEQMS_FORM_TEMPLATES_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.formTemplateList = response1;
            console.log('Data - ', this.formTemplateList);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];

              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);

              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);

              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const formTemplate of this.formTemplateList) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    formTemplate[dataType.columnName] = formTemplate[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
              this.labelcall();
            });
            this.message.gridList = this.formTemplateList;
            this.collectionSize = this.formTemplateList.length;
            this.totalPages = Math.ceil(this.formTemplateList.length / this.itemsPerPage);

          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  stagesList: any = [];
  selectedApprover: any = null;
  approverDropdown: any = [];
  dropDownDataForRepeatIntervalUnit: any = [];
  ngOnInit() {
    this.getcallMethod();
    this.appService.getOneQmsNonorgModuleStagesDetails("FORMS").subscribe((data: any) => {
      this.stagesList = data;
      this.selectBoxForStages();
    })
    this.isProcessing = true;
    this.appService.getFormTemplateApprovers().subscribe((data: any) => {
      this.isProcessing = false;

      this.approverDropdown = data?.map((item: any) => ({
        valueExp: item.userId,
        displayExp: item.userFullname.trim()
      })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp))
    })
  }


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.formTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.formTemplateList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.formTemplateListTemp = this.formTemplateList;
      this.pager = this.paginationService.getPager(this.formTemplateListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.formTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
      if (this.formTemplateList == undefined) {
        return this.formTemplateList;
      }
      if (!this.formTemplateList.length) {
        return this.formTemplateList;
      }
      if (filter) {
        this.formTemplateListTemp = this.formTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.formTemplateListTemp = this.formTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.formTemplateList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  focusEmpty() {
    console.log();
  }

  onClick(list: any) {
    let templateName = list.target.innerText.trim();
    this.message.masterDetails = this.formTemplateList.filter((x: any) => x.TEMPLATE_NAME.trim() === templateName);
    this.isProcessing = true;
    this.appService.getFormTemplateByTemplateId(this.message.masterDetails.TEMPLATE_ID).subscribe((response: any) => {
      this.formTemplateData = response[0];
      this.formTemplateData.allowToAddNewForm1 = this.formTemplateData.allowToAddNewForm == "Y";
      this.message.breadcrumbData.thirdLevel = "Forms and Logs (" + this.formTemplateData.templateName + ")";
      this.formTemplateData['isAddForm'] = false;
      this.router.navigate(['/dashboard/formTemplateDetail'], {
        state: {
          formTemplateData: this.formTemplateData
        }
      });
    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const template of this.formTemplateList) {
      template.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.formTemplateList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  templateName: any;
  templateNameRequiredMsg: any;

  stageName: any;
  stageNameRequiredMsg: any;
  fieldValidation() {
    this.templateName = document.getElementById('templateName') as HTMLInputElement;
    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.stageName = document.getElementById('stageName') as HTMLInputElement;
    this.stageNameRequiredMsg = document.getElementById('stageName-required-msg') as HTMLInputElement;

    if (this.formTemplateData.templateName == "") {
      this.templateName.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }

    if (this.selectedStages.length == 0) {
      this.stageName.style.border = '1px solid red';
      this.stageNameRequiredMsg.style.display = 'block';
    } else {
      this.stageName.style.border = 'none';
      this.stageNameRequiredMsg.style.display = 'none';
    }
  }

  onFieldFocusout() {
    if (this.templateNameRequiredMsg != undefined) {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }

    if (this.stageNameRequiredMsg != undefined) {
      this.stageName.style.border = 'none';
      this.stageNameRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }


  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('fieldPopup', { static: true }) fieldPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleFieldPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  fieldPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };


  selectedStages: any = [];
  stagesDropdown: any = [];
  selectBoxForStages() {
    for (const stage of this.stagesList) {

      const stageName = stage.oneQmsNonorgModuleStagesPk.stageName;

      this.stagesDropdown = this.stagesDropdown.concat({
        valueExp: stageName,
        displayExp: stageName
      });
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('stages') stages: MatSelect;
  isStagesSelected = false;


  toggleAllSelection(value: any) {
    if (value == 'stages') {
      if (this.isStagesSelected) this.stages.options.forEach((item: MatOption) => item.select());
      else this.stages.options.forEach((item: MatOption) => item.deselect());
    }

  }
  approversearchTxt: any;
  stagesSearchText: any;
  onStageSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length; })
    }
  }



  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  addMode: any = null;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Form Template";
    this.formTemplateData = {};
    this.formTemplateData.templateName = '';
    this.formTemplateData.templateDescription = null;
    this.formTemplateData.listOfStages = null;
    this.selectedStages = [];
    this.selectedApprover = null;
    this.addMode = null;
    this.formTemplateData.copyFromTemplateId = null;
    this.isProcessing = true;
    this.appService.getFormTemplateList()
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.templateDropdown = data;
      })
    setTimeout(() => { this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length; })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  positionValue: any = 1;
  filteredStages: any = [];
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Form Template"
    this.filteredStages = [];
    this.appService.getFormTemplateByTemplateId(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      this.formTemplateData = response[0];
      this.message.breadcrumbData.thirdLevel = "Forms and Logs (" + this.formTemplateData.templateName + ")";
      this.formTemplateData['isAddForm'] = false;
      this.router.navigate(['/dashboard/formTemplateDetail'], {
        state: {
          formTemplateData: this.formTemplateData
        }
      });
    })
  }

  templatesearchTxt: string = '';
  templateDropdown: any = [];


  refreshGridData() {
    this.getcallMethod();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  addAndEditFunction(formTemplateData: any) {
    this.isProcessing = true;
    if (formTemplateData.templateName == "" || this.selectedStages.length == 0) {
      this.fieldValidation();
      this.isProcessing = false;
    } else if (this.selectedApprover && this.selectedApprover == +this.message.getUserId()) {
      this.showSnackBar('The Template Creator and Template Approver cannot be the same person', 'E');
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {

        formTemplateData.approvedBy = this.selectedApprover ?? null;
        formTemplateData.allowToAddNewForm = "Y";
        formTemplateData.listOfStages = "";
        if (this.selectedStages.length > 0) {
          formTemplateData.listOfStages = this.selectedStages.join(",");
        }
        this.appService.createFormTemplate(formTemplateData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete formTemplateData.createdOn;
        delete formTemplateData.updatedOn;


        formTemplateData.allowToAddNewForm = formTemplateData.allowToAddNewForm1 ? "Y" : "N";
        formTemplateData.listOfStages = "";
        if (this.selectedStages.length > 0) {
          formTemplateData.listOfStages = this.selectedStages.join(",");

        }
        this.appService.updateFormTemplate(formTemplateData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = true;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

      }
    }

  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFormTemplateTemplateId: any;
  openDeletePopup(deleteRowData: any) {
    this.formTemplateData = deleteRowData;
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Form Template";
    this.deleteFormTemplateTemplateId = deleteRowData.TEMPLATE_ID;
    if (this.formTemplateData.deleteReason != undefined) {
      this.formTemplateData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFormTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        templateId: this.deleteFormTemplateTemplateId,
        deleteReason: this.formTemplateData.deleteReason,
      }
      this.appService.deleteFormTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.getcallMethod();
            this.visibleDeletePopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  openFormTemplateFields(list: any) {
    this.formTemplateData = list;
    this.appService.getFormTemplateByTemplateId(list.TEMPLATE_ID).subscribe((response: any) => {
      this.formTemplateData = response[0];
      this.formTemplateData.allowToAddNewForm1 = this.formTemplateData.allowToAddNewForm == "Y";
      if (this.formTemplateData.listOfStages) {
        this.selectedStages = this.formTemplateData.listOfStages.split(',');
        setTimeout(() => {
          this.isStagesSelected = this.stagesDropdown.length == this.selectedStages.length;
          this.formTemplateData.listOfStages.split(',').length == this.stagesList.length && this.stages.options.forEach((item: MatOption) => item.select());
        })

      }
      this.isProcessing = false;
      this.formTemplateData['isFrom'] = "Template";
      this.visibleFieldPopup = this.dialog.open(this.fieldPopup, this.fieldPopupConfig);
    })

  }

  goToDetailPage(editRowData: any) {

  }

  cancelFieldPopup() {
    this.visibleFieldPopup.close();
  }

  getInsideToCreateForm(data: any) {
    this.appService.getFormTemplateByTemplateId(data.TEMPLATE_ID).subscribe((response: any) => {
      this.formTemplateData = response[0];
      this.formTemplateData.allowToAddNewForm1 = this.formTemplateData.allowToAddNewForm == "Y";
      this.message.breadcrumbData.thirdLevel = "Forms and Logs (" + this.formTemplateData.templateName + ")";
      this.formTemplateData['isAddForm'] = true;
      this.router.navigate(['/dashboard/formTemplateDetail'], {
        state: {
          formTemplateData: this.formTemplateData
        }
      });
    })
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {}

  openAuditTrail(viewType: any, form_template: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : form_template.TEMPLATE_ID;
    this.auditTrail.gridName = 'FORM_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Forms Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(form_template);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Form Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
}
